import { h, Component } from 'preact'
import { route } from 'preact-router'

import { connect } from 'app/store'
import Button from 'app/components/Button'
import Input from 'app/components/Input'
import { downloadObjectAsJson, downloadObjectAsCSV } from '../util'
import escape from 'lodash.escape'
import { api } from 'app/util/api'

const bookmarkletStyle = {
  border: '2px dashed gray',
  padding: '8px 15px',
  borderRadius: '15px',
  color: '#6c757d', // text-muted
  textDecoration: 'none',
}

class Settings extends Component {
  constructor() {
    super()
    this.onLogout = this.onLogout.bind(this)
  }

  componentDidMount() {
    this.props.getMe()
    this.findBookmarks()
  }

  findBookmarks = async () => {
    const bookmarks = await api.get('/bookmark')

    this.setState({ bookmarks })
  }

  onLogout() {
    const { logout } = this.props

    localStorage.removeItem('unistorePersist')

    logout()

    route('/')
  }

  exportCSV = () => {
    const { bookmarks } = this.state

    const date = new Date().toISOString().substring(0, 10)
    const fileName = `${date}-manter-export`

    downloadObjectAsCSV(bookmarks, fileName)
  }

  exportJSON = () => {
    const { bookmarks } = this.state
    const date = new Date().toISOString().substring(0, 10)
    const fileName = `${date}-manter-export`

    downloadObjectAsJson(bookmarks, fileName)
  }

  renderBookmarklet() {
    const baseUrl = 'https://manter.app/submit'
    const bookmarkletUrl = `javascript:window.location=%22${baseUrl}?u=%22+encodeURIComponent(document.location)+%22&t=%22+encodeURIComponent(document.title)`

    return (
      <a class="cursor-move" style={bookmarkletStyle} rel="nofollow" href={escape(bookmarkletUrl)}>
        Save to Manter
      </a>
    )
  }

  render() {
    const { email } = this.props.me

    return (
      <div>
        <h2 class="mb-5 font-weight-bold">Settings</h2>
        <div className="row d-flex align-items-stretch">
          <div className="col-12 col-md-4 py-2">
            <div className="card card-body h-100">
              <h5 class="card-title">Bookmarklet</h5>
              <p className="card-text mb-5  text-muted">
                Drag the button below to your bookmarks bar to save links via bookmarklet.
              </p>
              <div class="mt-auto"> {this.renderBookmarklet()}</div>
            </div>
          </div>
          <div className="col-12 col-md-4 py-2">
            <div className="card card-body h-100">
              <h5 class="card-title">Export</h5>
              <p className="card-text text-muted">Download your data on multiple formats.</p>
              <div class="mt-auto">
                <Button class="mr-2" onClick={this.exportJSON}>
                  JSON
                </Button>
                <Button class="mr-2" disabled onClick={this.exportCSV}>
                  CSV
                </Button>
                {/* <Button disabled>XML</Button> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 py-2">
            <div className="card card-body h-100">
              <h5 class="card-title">Account</h5>
              <p className="card-text text-muted">Signed in as {email}.</p>
              <div class="mt-auto">
                <Button onClick={this.onLogout}>Logout</Button>
              </div>
            </div>
          </div>
        </div>
        {/* <div class="mb-5">
          <h4 class="mb-3">Bookmarklet</h4>
          <hr />
          <p class="mb-4 text-muted">Drag the link below to your bookmarks bar</p>
          {this.renderBookmarklet()}
        </div>

        <div class="mb-5">
          <h4 class="mb-3">Export</h4>
          <hr />
          <p>Bookmarks:</p>
          <Button class="mr-2" onClick={this.exportJSON}>
            JSON
          </Button>
          <Button class="mr-2" onClick={this.exportCSV}>
            CSV
          </Button>
          <Button disabled>XML</Button>
        </div>

          <h4 class="mb-3">Account</h4>
          <hr />

          <Input value={email} disabled required label="Email" containerClass="d-inline-block" />
          <Button onClick={this.onLogout} class="ml-2">
            Logout
          </Button>
        </div> */}
      </div>
    )
  }
}

export default connect(
  'me',
  Settings,
)



// WEBPACK FOOTER //
// ./pages/Settings.js